import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

import { RejectedProctorRequestEditionFormProvider } from '../../providers';
import { ProctorRequestDetailsReadOnlyFields } from '../proctor-request-details-read-only-fields';
import { ProctorRequestRejectedVerdict } from '../proctor-request-rejected-verdict';
import { RejectedProctorRequestEditionFormLogic } from '../rejected-proctor-request-edition-form-logic';

export default function RejectedProctorRequestDetails() {
  const hasPermissionToUpdate = useHasPermission(
    APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.UPDATE,
  );

  if (!hasPermissionToUpdate) {
    return (
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
        <ProctorRequestDetailsReadOnlyFields />
        <ProctorRequestRejectedVerdict />
      </Flex>
    );
  }

  return (
    <RejectedProctorRequestEditionFormProvider>
      <RejectedProctorRequestEditionFormLogic />
    </RejectedProctorRequestEditionFormProvider>
  );
}
